import SingleCourseOverview from './Overview.gql';

export default SingleCourseOverview;
